export const PRIVATE_PARTY_FEES = Object.freeze({
  additionalKid: 15,
  additionalAdult: 10,
  taxRate: 0.1025,
});

export const formatPackagePrice = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(amount);

export const formatMoney = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);

export const privatePartyPackages = [
  {
    id: 1,
    title: "Prince/Princess Celebration",
    description: "Playtime, pizza, and a cake celebration.",
    price: 1800,
    durationHours: 2,
    includedKids: 25,
    includedAdults: 35,
    includedPizzas: 5,

    details: [
      { label: "Helpers", value: "2-3" },
      { label: "Large one-topping pizzas", perIncludedPizza: true },
      { label: "Organic Juice Boxes", perIncludedChild: true },
      { label: "Water Bottles", value: "For All Guests" },
      { label: "Non-Slip Socks", value: "For All Kids" },
    ],
    additionalInfo: [
      "Coffee/Tea served with creamer & sugar",
      "Plates, napkins, cups, flatware for adults",
      "Cake celebration (cutting, serving)",
      "Cake stands provided (acrylic)",
      "Complimentary background music for extra fun and cheer!",
    ],
  },

  {
    id: 2,
    title: "Fairy Tale Celebration",
    description: "Themed table settings, playtime, and a cake celebration.",
    price: 2300,
    durationHours: 2.5,
    includedKids: 35,
    includedAdults: 45,
    includedPizzas: 6,

    details: [
      { label: "Helpers", value: "2-3" },
      { label: "Large one-topping pizzas", perIncludedPizza: true },
      { label: "Organic Juice Boxes", perIncludedChild: true },
      { label: "Water Bottles", value: "For All Guests" },
      { label: "Non-Slip Socks", value: "For All Kids" },
    ],
    additionalInfo: [
      "Coffee/Tea served with creamer & sugar",
      "Themed plates napkins, and centerpieces for the kid's table",
      "Plates, napkins, cups, flatware for adults",
      "Cake celebration (cutting, serving)",
      "Cake plates & forks provided",
      "Cake stands are provided, with clear, white options and a variety of colors and designs to choose from",
      "Complimentary background music for extra fun and cheer!",
    ],
  },
  {
    id: 3,
    title: "Luminous Castle Celebration",
    description: "Themed table settings and goodie bags for all kids.",
    price: 3000,
    durationHours: 3,
    includedKids: 45,
    includedAdults: 55,
    includedPizzas: 8,

    details: [
      { label: "Helpers", value: "2-3" },
      { label: "Large one-topping pizzas", perIncludedPizza: true },
      { label: "Organic Juice Boxes", perIncludedChild: true },
      { label: "Sodas", value: "For Adults" },
      { label: "Water Bottles", value: "For All Guests" },
      { label: "Non-Slip Socks", value: "For All Kids" },
    ],
    additionalInfo: [
      "Coffee/Tea served with creamer & sugar",
      "Themed plates napkins, and centerpieces for the kid's table",
      "Plates, napkins, cups, flatware for adults",
      "Cake celebration (cutting, serving)",
      "Cake plates & forks provided",
      "Cake stands are provided, with clear, white options and a variety of colors and designs to choose from",
      "Goodie bags for all kids",
      "Goodie bag display stand provided",
      "Complimentary background music for extra fun and cheer!",
    ],
  },
  {
    id: 4,
    title: "Majestic Royal Celebration",
    description: "Goodie bags and themed entertainment for the celebration.",
    price: 4000,
    durationHours: 4,
    includedKids: 50,
    includedAdults: 65,
    includedPizzas: 9,

    details: [
      { label: "Helpers", value: "2-3" },
      { label: "Large one-topping pizzas", perIncludedPizza: true },
      { label: "Organic Juice Boxes", value: "Unlimited" },
      { label: "Sodas", value: "For Adults" },
      { label: "Water Bottles", value: "For All Guests" },
      { label: "Non-Slip Socks", value: "For All Kids" },
    ],
    additionalInfo: [
      "Coffee/Tea served with creamer & sugar",
      "Themed plates napkins, and centerpieces for the kid's table",
      "Plates, napkins, cups, flatware for adults",
      "Cake celebration (cutting, serving)",
      "Cake plates & forks provided",
      "Cake stands are provided, with clear, white options and a variety of colors and designs to choose from",
      "Goodie bags for all kids",
      "Goodie bag display stand provided",
      "Character for your themed party (1 hour) OR Sparkly painting and glitter tattoos",
      "1 free return open play pass for the birthday child and their sibling(s)",
      "Complimentary background music for extra fun and cheer!",
    ],
  },
];

// Inclusion rows read their package's quantities instead of duplicating them.
// Majestic's explicit "Unlimited" juice value remains unchanged.
export function getPackageDetails(pkg) {
  return pkg.details.map((detail) => ({
    ...detail,
    value: detail.perIncludedChild
      ? String(pkg.includedKids)
      : detail.perIncludedPizza
        ? String(pkg.includedPizzas)
        : detail.value,
  }));
}

// All offerings have no service fees. Optional items remain priced separately.
export const weekdayPartyPackages = [
  {
    id: 1,
    title: "Non Private Party",
    price: 300,
    includedPizzas: 3,
    details: [
      {
        label: "Party Time",
        value: "2 Hours",
      },
      {
        label: "5 kids and 10 adults",
        value: "",
      },
      {
        label: "Large one-topping pizzas",
        perIncludedPizza: true,
      },
      {
        label: "Non-Slip Socks",
        value: "For All Kids",
      },
      {
        label: "Coffee/Tea served with creamer & sugar",
        value: "",
      },
      {
        label: "Water Bottles",
        value: "For All Guests",
      },
      {
        label: "Organic Juice Boxes",
        value: "For all kids",
      },
      {
        label: "Additional food and cake are allowed.",
        value: "",
      },
      {
        label: "+ 30 mins of playtime",
        value: "$200",
      },
      {
        label: "+ 1 hr of playtime",
        value: "$300",
      },
    ],
    additionalInfo: [],
  },
  {
    id: 2,
    title: "Non Private Party",
    price: 700,
    includedPizzas: 4,
    details: [
      {
        label: "Party Time",
        value: "2 Hours",
      },
      {
        label: "15 kids and 20 adults",
        value: "",
      },
      {
        label: "Large one-topping pizzas",
        perIncludedPizza: true,
      },
      {
        label: "Non-Slip Socks",
        value: "For All Kids",
      },
      {
        label: "Coffee/Tea served with creamer & sugar",
        value: "",
      },
      {
        label: "Water Bottles",
        value: "For All Guests",
      },
      {
        label: "Organic Juice Boxes",
        value: "For all kids",
      },
      {
        label: "Additional food and cake are allowed.",
        value: "",
      },
      {
        label: "+ 30 mins of playtime",
        value: "$200",
      },
      {
        label: "+ 1 hr of playtime",
        value: "$300",
      },
    ],
    additionalInfo: [],
  },
];

export const partyAddOns = {
  id: 1,
  title: "Optional party add-ons",
  price: "From $25",
  details: [
    {
      label: "+30mins of playtime",
      value: "$300 (only for packages)",
    },
    {
      label: "+1hr of playtime",
      value: "$400 (only for packages)",
    },
    {
      label: "Cotton Candy Station",
      value: " $200",
    },
    {
      label: "Sparkly Painting & Glitter Tattoos",
      value: " $150/1hr",
    },
    {
      label: "Friendship Bracelet-Making",
      value: " $200/1hr",
    },
    {
      label: "Balloon Decorations",
      value: "Starting at $500",
    },
    {
      label: "Themed Party Character Appearance",
      value: "Starting at $250",
    },
    {
      label: "Character Cutouts",
      value: "Starting at $50",
    },
    {
      label: "Arch Backdrops",
      value: "Starting at $150",
    },
    {
      label: "Professional Photography",
      value: "Starting at $150/1hr",
    },
    {
      label: "Food Catering",
      value: "Price Varies",
    },
    {
      label: "Royal Sipper Cups",
      value: "Price Varies",
    },
    {
      label: "Themed Marshmallow Treats.",
      value: "$90(20cnt)",
    },
    {
      label: "Party Goodie Bags",
      value: " $10 each",
    },
    {
      label: "Goodie Bag Display Stand (one)",
      value: " $150",
    },
    {
      label: "Large One-Topping Pizza (one)",
      value: " $25 each",
    },
  ],
  additionalInfo: [],
};

export const locationRental = {
  id: 2,
  title: "Rent Out Location",
  price: 1000,
  details: [
    {
      label: "Duration",
      value: "1 Hour",
    },
    {
      label:
        "For photoshoots, commercials, and private play only. Birthdays are not permitted!",
      value: "",
    },
  ],
  additionalInfo: [],
};
